<script setup lang="ts">
  import { computed } from 'vue';

  import Button from '../Button/Button.vue';
  import type { IconName } from '../Icon/Icon.types';
  import Icon from '../Icon/Icon.vue';

  enum ChevronToggleDirections {
    Up = 'up',
    Down = 'down',
    Left = 'left',
    Right = 'right',
  }

  export type ChevronToggleDirection = `${ChevronToggleDirections}`;

  export interface ChevronToggleProps {
    direction?: ChevronToggleDirection;
  }

  const props = withDefaults(defineProps<ChevronToggleProps>(), {
    direction: 'down',
  });

  const emit = defineEmits<{ (e: 'click'): void }>();

  const icon = computed<IconName>(() => `chevron-${props.direction}`);
</script>

<template>
  <Button class="stash-chevron-toggle" icon data-test="stash-chevron-toggle" @click="emit('click')">
    <Icon :name="icon" :data-test="`icon|${icon}`" />
  </Button>
</template>
